'use strict';
var parent = require('../../actual/object/from-entries');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/object/from-entries.js
// module id = 362
// module chunks = 0